/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAttachmentRequest } from './CreateAttachmentRequest';
import {
    CreateAttachmentRequestFromJSON,
    CreateAttachmentRequestFromJSONTyped,
    CreateAttachmentRequestToJSON,
    CreateAttachmentRequestToJSONTyped,
} from './CreateAttachmentRequest';

/**
 * The inbox item to create.
 * @export
 * @interface CreateInboxItemRequest
 */
export interface CreateInboxItemRequest {
    /**
     * 
     * @type {CreateAttachmentRequest}
     * @memberof CreateInboxItemRequest
     */
    attachment: CreateAttachmentRequest;
    /**
     * The source of the upload (e.g., "telegram", "web_upload").
     * @type {string}
     * @memberof CreateInboxItemRequest
     */
    source: string;
    /**
     * Optional text message that accompanied the attachment.
     * @type {string}
     * @memberof CreateInboxItemRequest
     */
    text?: string;
}

/**
 * Check if a given object implements the CreateInboxItemRequest interface.
 */
export function instanceOfCreateInboxItemRequest(value: object): value is CreateInboxItemRequest {
    if (!('attachment' in value) || value['attachment'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function CreateInboxItemRequestFromJSON(json: any): CreateInboxItemRequest {
    return CreateInboxItemRequestFromJSONTyped(json, false);
}

export function CreateInboxItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInboxItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'attachment': CreateAttachmentRequestFromJSON(json['attachment']),
        'source': json['source'],
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function CreateInboxItemRequestToJSON(json: any): CreateInboxItemRequest {
    return CreateInboxItemRequestToJSONTyped(json, false);
}

export function CreateInboxItemRequestToJSONTyped(value?: CreateInboxItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attachment': CreateAttachmentRequestToJSON(value['attachment']),
        'source': value['source'],
        'text': value['text'],
    };
}

